<template>
	<div>
	</div>
</template>

<script>
	import create from "./Create.vue";
	import profile from "./Profile.vue";
	import store from "../store";

	export default {
		components: {
			create,
			profile,
		},
		data: function () {
			return {
				store: {},
			};
		},
		name: "Main",
		mounted: async function () {
			this.store = store;

			if (store.state.user.rules && store.state.user.rules.login) {
				this.$router.push("/" + store.state.user.rules.login);
			}
			else if ((
					store.state &&
					store.state.user.rules &&
					store.state.user.rules.actions
				))
			{
				this.$router.push("/actions");
			}
			else if (!(
					store.state &&
					store.state.user.rules &&
					!store.state.user.rules.projects
				))
			{
				this.$router.push("/create");
			}
			else
			{
				this.$router.push("/profile");
			}

		},
	};
</script>

<style></style>
